import { Component, EventEmitter, inject, Output } from '@angular/core';
import { LoadingOptions } from '../../../../../models/shared/loading-options';
import { ActivatedRoute, Router } from '@angular/router';
import { ForgotPasswordRequest } from '../../../../../models/users/requests/forgot-password-request';
import { BaseComponent } from '../../../../../models/base/base-component';
import { BehaviorSubject, Observable } from 'rxjs';
import { ForgotPasswordViewModel } from '../../../viewModels/forgot-password-view-model';
import { PortalService } from '../../../../../services/portal/portal.service';
import { createForgotPasswordFormGroup } from '../../../forms/forgot-password-form-group';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss', '../auth.component.scss']
})
export class ForgotPasswordComponent extends BaseComponent {
  viewModel = inject(ForgotPasswordViewModel);
  route = inject(ActivatedRoute);
  portalService = inject(PortalService);

  @Output() loadingOpts = new EventEmitter<LoadingOptions>();

  // View
  public _loadingOpts = new BehaviorSubject(LoadingOptions.default());
  public loadingOpts$ = this._loadingOpts as Observable<LoadingOptions>;
  // Variables
  public formGroup = createForgotPasswordFormGroup();
  public formSubmitted = false;
  public readonly resetPasswordText = $localize`Reset Password`;
  public readonly emailSentText = $localize`Reset Password Link Sent`;

  constructor(private router: Router) {
    super();
  }

  // Prefill runs in setupViews (ngOnInit) so synchronous emissions patch the form before the first change detection pass
  setupViews() {
    this.viewModel.getUrlParams(this.route);
    this.viewModel.preFillEmail$.subscribeWhileAlive({
      owner: this,
      next: email => {
        if (!!email) {
          this.formGroup.controls.email.patchValue(email);
        }
      }
    });
  }

  setupBindings() {
    this.viewModel.loadingOpts$.subscribeWhileAlive({
      owner: this,
      next: opts => this.loadingOpts.emit(opts)
    });
  }

  public submit(): void {
    this.formSubmitted = true;
    if (this.formGroup.invalid) {
      return;
    }
    const req = new ForgotPasswordRequest(this.formGroup.controls.email.value);
    this.portalService.portalType$.once(type => {
      this.viewModel.forgotPassword(req, type);
    });
  }

  backToLogin() {
    this.router.navigate(['/auth/sign-in']);
  }
}
